// extracted by mini-css-extract-plugin
export var infoRow = "_sz-2";
export var labelContainer = "_sz-0";
export var rightInfo = "_sz-1";